import { useRooms } from '../../hooks/useRooms';
import { useCurrentInstitution } from '../institutions/useCurrentInstitution';
import { useGetUserId } from '../../hooks/useCredentials';
import { useEffect } from 'react';
import { useGrowthBookConfig } from '../useGrowthBookConfig';
import { MembershipType } from '../../services/room';
import { useService } from '../useService';

export const usePersonalRoom = (): {
  id: string | undefined;
  passcode: string | null;
  roomUrl: string;
  cameraOff?: boolean;
  isPasscodeEnabled: boolean;
  slug: string;
  isError: boolean;
  isLoading: boolean;
} => {
  const userId = useGetUserId();
  const { institution } = useCurrentInstitution();
  const { updateGrowthBookConfig } = useGrowthBookConfig();

  /**
   * TODO: remove this once we make sure it never runs on the patient side.
   */
  const isProvider = useService('$context') === 'provider';

  const { rooms, isError, isLoading } = useRooms({
    userId,
    institutionId: institution?.id ?? null,
    skip: !isProvider,
  });

  const room = rooms?.find(
    (r) => r.node.membershipType === MembershipType.Owner,
  )?.node;
  const roomId = room?.id;
  const origin = typeof window === 'undefined' ? '' : window.location.origin;
  const roomUrl = `${origin}/${room?.slug ?? ''}`;

  /**
   * Add the roomId to the GrowthBook config for the provider.
   */
  useEffect(() => {
    if (isProvider) {
      updateGrowthBookConfig({ roomId });
    }
  }, [roomId, isProvider]);

  return {
    passcode: room?.passcode || null,
    cameraOff: room?.cameraOff,
    roomUrl,
    id: room?.id,
    isPasscodeEnabled: room?.isPasscodeEnabled ?? false,
    slug: room?.slug ?? '',
    isError,
    isLoading,
  };
};
